// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"05245f87","282":"5d1e9504","321":"9de73800","522":"9de73800"}[chunkId] + ".css";
};